import { connect } from 'react-redux';
import { compose, withHandlers, withStateHandlers } from 'recompose';
import { withTranslation } from 'react-i18next';

import { selectors, actions } from 'state/auth';
import LoginForm from 'components/auth/LoginForm/styled';

const enhance = compose(
  withTranslation('authLoginForm'),
  connect(
    (state) => ({
      error: selectors.getAuthError(state),
    }),
    {
      login: actions.login,
    }
  ),
  withStateHandlers(
    ({ username = '', password = '' }) => ({
      username,
      password,
    }),
    {
      setUsername:
        () =>
        (e, { value }) => ({
          username: value,
        }),
      setPassword:
        () =>
        (e, { value }) => ({
          password: value,
        }),
    }
  ),
  withHandlers({
    handleSubmit:
      ({ login, username, password }) =>
      (e) => {
        e.preventDefault();
        login({ username, password });
      },
  })
);

export { LoginForm, enhance };
export default enhance(LoginForm);
